import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../../scss/pages/MyCertificates/SpotRewards/SpotRewards.scss";
import NoRecordsFound from "../../../asset/svg/no-certificate-found.svg";
import myCertificate from "../../../asset/svg/CertificateConstant.svg";
import SpotRewardsIcon from "../../../asset/svg/SpotRewardsIcon.svg";
import { useNavigate } from "react-router";
import { CERTIFICATE_DOWNLOAD_PATH } from "../../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { GET_SPOT_REWARDS_DATA } from "../../../sagas/type";
import jsPDF from "jspdf";
import moment from "moment";

function SpotRewards(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { SpotRewards } = useSelector(mapStateToProps);

  const handleSelectCertificateCard = (item) => {
    navigate(CERTIFICATE_DOWNLOAD_PATH, {
      state: {
        PdfUrl: item?.certificateUrl,
        certificateNo: item?.certificateNumber,
        pageIndex: 1,
      },
    });
  };

  useEffect(() => {
    dispatch({
      type: GET_SPOT_REWARDS_DATA,
    });
  }, []);
  return (
    <div className="SpotRewards-Container">
      <div className="SpotRewards-Container_Parent-container-grid">
        {SpotRewards && SpotRewards?.length > 0 ? (
          <div className="SpotRewards-Container_Parent-container-grid_cards-grid">
            {SpotRewards?.map((item) => {
              return (
                <div
                  key={item?.CertificateId}
                  className="SpotRewards-Container_Parent-container-grid_cards-grid_card-Parent-Container"
                  onClick={() => handleSelectCertificateCard(item)}
                >
                  <div className="SpotRewards-Container_Parent-container-grid_cards-grid_card-Parent-Container_card-container">
                    <img
                      src={SpotRewardsIcon}
                      className="SpotRewards-Container_Parent-container-grid_cards-grid_card-Parent-Container_card-container_card-Image"
                    />
                    <Typography
                      sx={{
                        color: "#767F94",
                        fontSize: "10px",
                        marginTop: "2px",
                        fontWeight: 600,
                      }}
                    >
                      {moment(item?.generatedAt).format("DD / MM / YYYY")}
                    </Typography>
                    <Typography
                      className="SpotRewards-Container_Parent-container-grid_cards-grid_card-Parent-Container_card-container_Name"
                      value="name"
                    >
                      {item?.certificateName}
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="SpotRewards-Container_No-records-found">
            <div className="SpotRewards-Container_No-records-found_child">
              <img
                className="SpotRewards-Container_No-records-found_child_Image"
                src={NoRecordsFound}
                alt="No Records Found"
              />
              <div className="SpotRewards-Container_No-records-found_child_Text-content">
                <Typography className="SpotRewards-Container_No-records-found_child_Text-content_Text">
                  No Certificate Found
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    SpotRewards: state?.spotRewards?.SpotRewards,
  };
};

export default SpotRewards;
